import Flex from '@Components/Bases/Flex';
import { MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

type ReportTopicDetailProps = {
  years: number[];
  selectedYear: string;
  setSelectedYear: (year: string, reportId?: string) => void;
};

const ReportTopicDetail = ({
  years,
  selectedYear,
  setSelectedYear,
}: ReportTopicDetailProps) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const queryYear = searchParams.get('year');
    const queryReportId = searchParams.get('report');

    if (queryReportId && !queryYear) {
      setSelectedYear('', queryReportId);
    } else if (queryYear) {
      setSelectedYear(queryYear, queryReportId || undefined);
    }
  }, [searchParams, years, setSelectedYear]);

  const handleChange = (event: SelectChangeEvent<string>) => {
    setSelectedYear(event.target.value);
    navigate('/');
  };

  return (
    <Flex justifyContent="space-between" width={1}>
      <Typography variant="h3">ข้อมูลรายงาน</Typography>
      <Flex alignItems="center" justifyContent="center" gap={1}>
        <Typography>ปีข้อมูล</Typography>
        <Select
          labelId="year-select-label"
          id="year-select"
          value={selectedYear}
          onChange={handleChange}
          displayEmpty
          defaultValue="เลือกปี"
          sx={{ minWidth: 80, bgcolor: 'white' }}
        >
          <MenuItem value="">เลือกปี</MenuItem>
          {years.map((year: number, index: number) => (
            <MenuItem key={index} value={String(year)}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </Flex>
    </Flex>
  );
};

export default ReportTopicDetail;
